// extracted by mini-css-extract-plugin
export default {"toast-container":"MaToast_toast-container__yNlxQ","toast":"MaToast_toast__jGOek","slideInRight":"MaToast_slideInRight__0NIhg"};